import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=a407e1e8&scoped=true&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=a407e1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a407e1e8",
  null
  
)

export default component.exports